import get from 'lodash.get';

export default function consentFactory(services) {
  const thisService = {
    init,
  };

  return thisService;

  //////////////

  function init() {
    const clientConfig = services.session.getClientConfig();
    let optimizeScript = get(clientConfig, 'consent.optimizeScript');
    if (optimizeScript) {
      initExperiments();
      let optimizeScriptElement = services.document.createElement('script');
      optimizeScriptElement.src = optimizeScript;
      optimizeScriptElement.setAttribute('type', 'text/javascript');
      optimizeScriptElement.setAttribute('charset', 'UTF-8');
      services.document.head.appendChild(optimizeScriptElement);
    }
  }

  function initExperiments() {
    // HardCoding this for now, eventually it will be an array returned in ClientConfig
    let experiments = [
      'ideas-sortedByScores',
    ];

    window.dataLayer = window.dataLayer || [];
    experiments.forEach(exp => {
      let item = {};
      item[exp] = false;
      window.dataLayer.push(item);
    });
  }
}
